<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <MessageForm
          v-model="message"
          title="Editace zprávy"
          :loading="saving"
          :edit="true"
          @save="save"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import MessageForm from '@/components/forms/MessageForm.vue'

export default {
  name: 'MessageEdit',
  components: {
    MessageForm,
  },
  data() {
    return {
      message: {},
      loading: false,
      saving: false,
    }
  },
  created() {
    this.loadMessage()
  },
  methods: {
    ...mapActions({
      getMessage: 'message/getMessage',
      updateMessage: 'message/updateMessage',
    }),
    loadMessage() {
      this.loading = true
      this.getMessage(this.$route.params.id)
        .then((response) => {
          this.message = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      this.saving = true
      this.updateMessage(this.message)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$router.back()
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
